import React, { Fragment, useState} from "react";

// components
import OrdersGrid from "../../../Common/Orders/OrdersGrid";
import HeaderActions from "../../Navigation/HeaderActions";
import { useElsewhereEmpty } from "../../../Common/Orders/useElsewhereEmpty";

interface Props {
  tableData: any[];
  fetchingOrders: boolean;
  exportButton: () => JSX.Element;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: any;
  featuresAllowed: string[];
}

const NO_BUDGETS = "No hay presupuestos en este rango";

export default (props: Props) => {

  const initialSortValue = [
    { field: null, dir: null },
  ];
  const [sort, setSort] = useState(initialSortValue);
  const empty = useElsewhereEmpty("budgets", NO_BUDGETS, props.activeFilters.filter, !props.fetchingOrders && props.total === 0);

  return (
      <Fragment>
        <HeaderActions>
          {props.exportButton && props.exportButton()}
        </HeaderActions>
        <OrdersGrid
            tableData={props.tableData}
            loading={props.fetchingOrders}
            requestNewPage={props.sendFilters}
            take={props.take}
            skip={props.skip}
            total={props.total}
            sort={sort}
            setSort={setSort}
            featuresAllowed={props.featuresAllowed}
            empty={empty}
        />
      </Fragment>
  );
};
